module.exports = __webpack_public_path__ + "8c234845c94081ab0842e6073b512ec4.MP3";